const Config = {
  LoginPath: process.env.VUE_APP_LOGIN_PATH || '/backend/rest/system/web-auth-user/',
  APIPath: process.env.VUE_APP_API_PATH || '/backend/rest/',
  RZAppKey: process.env.VUE_APP_RZ_APP_KEY || '1001',
  FAKey: process.env.VUE_APP_FA_KEY || '1001',
  RSDemoAppKey: process.env.VUE_APP_RS_DEMO_APP_KEY || '153724147994715',
  ThemeName: process.env.VUE_APP_RZ_THEME_NAME || null,
  StageName: process.env.VUE_APP_RZ_STAGE_NAME || null,
  CricketPushEndpoint: process.env.VUE_APP_CRICKET_PUSH_END_POINT || 'push01.cricketapi.com',
  FootballPushEndpoint: process.env.VUE_APP_FOOTBALL_PUSH_END_POINT || 'push01.footballapi.com',
  SocketProxyEndpoint: process.env.VUE_APP_SOCKET_PROXY_END_POINT || '',
  title: 'Litzscore V6',

  kabaddiSeasonKey: 'pkl_2019'
}

export default Config